import axios from 'axios';

export default axios.create({
   baseURL:'https://dev.virtualearth.net/REST/v1/Routes'
});